import DepositHistoryPage, { getDefaultPageUI } from "components/pages/DepositHistoryPage";
import { useBCMSContext, BCMSRecord, BCMSStateManagerCRUD } from "bcms-react";
import Classes, { Deposit } from "model";

export default function CaptureMabiDepositsSearch(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const deposit = Deposit.init({
        id: 100,
        date: 0,
        account: 0,
        amount: 20,
        status: "Not Available",
        source: "Mobile Phone",
        isCheck: "true"
    });

    Deposit.create(deposit)
        .submit(Classes);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showSearchAccordion" ], true)
        .submit();

    return <DepositHistoryPage ui={ ui } />
}